import { api } from 'app/store';
import { CONFIGURATION_ENDPOINTS } from 'api';
import { makeUseRequest } from 'hooks';
import { IConfigContent } from 'types';

export const useConfigContent = <A extends CONFIGURATION_ENDPOINTS>(path: A) =>
  makeUseRequest<IConfigContent[A]>(api.configuration.fetch.bind(api.configuration, path));
